import { useLingui } from '@lingui/react/macro';

import { DesktopBrandFilter } from '@/components/SharedFilters/BrandFilter/DesktopBrandFilter';
import { useSettingsScope } from '@/routes/SettingsBeta/SettingsContext';

import { useFilters } from '../FiltersState';

export const FiltersBrand = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();
  const { scope } = useSettingsScope();
  const organizationId = scope?.scope === 'organization' ? scope.organizationId : undefined;

  const {
    brands: { brands, setBrands },
  } = useFilters();

  return (
    <DesktopBrandFilter
      selectedBrands={brands}
      setSelectedBrands={setBrands}
      brandsQuery={{ organizationId, limit: 500, offset: 0 }}
      tag={tag}
      label={t({
        id: 'settings.organization.data-catalogs.products.filters.brand.label',
        message: 'Brand',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.data-catalogs.products.filters.brand.search',
        message: 'Search brands',
      })}
      tagMultipleSelectionLabel={(selectedBrandsNumber) =>
        i18n._({
          id: 'settings.organization.data-catalogs.products.filters.brand.multiple',
          message: '{selectedBrandsNumber} brands',
          values: { selectedBrandsNumber },
        })
      }
    />
  );
};
